import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

function DeleteButtonUserDataMobile(props) {
  return (
    // <div
    //   className="square-button-mobile delete-button-color"
    //   title="Delete"
    //   onClick={props.handleOpen}
    // >
    //   <DeleteForeverIcon style={{ font: 18, color: "white" }} />
    // </div>
    <div
      title={props.title || "Delete"}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        if (props.onClick) return props.onClick(e);
        if (props.handleOpen) return props.handleOpen(e);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (props.onClick) return props.onClick(e);
          if (props.handleOpen) return props.handleOpen(e);
        }
      }}
      style={{
        backgroundColor: "#dc2626", // rouge
        width: 36,
        height: 36,
        borderRadius: 8,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      }}
    >
      <DeleteForeverIcon style={{ fontSize: 18, color: "white" }} />
    </div>
  );
}

export default DeleteButtonUserDataMobile;
